import React from "react";
import {
  DialogTitle,
  DialogContent
} from '@rmwc/dialog';
import { TextField } from '@rmwc/textfield';

import '@material/dialog/dist/mdc.dialog.css';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';

class DatumSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      distanceparameters: props.distanceparameters,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (event.target.id === "tipToDatumA") {
      this.setState({
        distanceparameters: {
          ...this.state.distanceparameters,
          tipToDatumA: event.target.valueAsNumber,
        },
      }, () => {
        this.props.onChange(this.state.distanceparameters);
      });
    } else if (event.target.id === "tipToDatumB") {
      this.setState({
        distanceparameters: {
          ...this.state.distanceparameters,
          tipToDatumB: event.target.valueAsNumber,
        },
      }, () => {
        this.props.onChange(this.state.distanceparameters);
      });
    }
  }
  render() {
    return (
      <div>
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent style={{paddingTop: '15px'}}>
          {(this.props.labels.length > 1) ? <>
          <TextField
            id="tipToDatumB"
            type="number"
            outlined
            style={{width: '100%'}}
            label={this.props.labels[1]}
            value={this.state.distanceparameters.tipToDatumB}
            onChange={(event) => this.handleChange(event)}/>
          <br/>
          <br/>
          </> : <></>}
          <TextField
            id="tipToDatumA"
            type="number"
            outlined
            style={{width: '100%'}}
            label={this.props.labels[0]}
            value={this.state.distanceparameters.tipToDatumA}
            onChange={(event) => this.handleChange(event)}/>
        </DialogContent>
      </div>
    );
  };
};

export default DatumSettings;